import styled from 'styled-components'
import { DevicesListItemCol } from '../Devices/DeviceList'

export const PlantCareListItemCol = styled(DevicesListItemCol)`

`

export const PlantCareListImageWrapper = styled.div`
    width: 70%;
    height: 100px;
    margin: 10px auto 0;
`

export const PlantCareListImage = styled.img`
    object-fit: ${props => (props.contain ? 'contain' : 'cover')};
    width: 100%; 
    height: 100px;
    background-color: transparent;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
`

export const PlantCareListItemContent = styled.div`
    border: 1px solid rgba(136,136,136, 0.3);
    border-radius: 10px; 
    box-shadow: 0 0 10px rgba(136,136,136, 0.4);
`

export const PlantCareListItemInnerContent = styled.div`
    width: 100%;
    text-align: center;
    padding: 10px 0;
    position: relative;
`

export const PlantCareItemValue = styled.div`
    line-height: 20px;
    font-size: 0.9rem;
    overflow: hidden;
    word-wrap: break-word;
    text-overflow: ellipsis;
    white-space: nowrap;
    
`

export const PlantCareItemName = styled(PlantCareItemValue)`
    font-weight: bold;
`



// WEBPACK FOOTER //
// ./src/components/StyledComponents/Plants/PlantCare.js